import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";
import Api from '../../services/api';
import { toast } from "react-toastify";
import withRouter from "../../services/withRouter";



class SchemesServices extends React.Component {
    
  
    componentDidMount = async () => {
        window.scrollTo(0, 0);
        this.getCategories();
    };



    getCategories = async()=>{
        var scheme_type = await this.props.params.scheme_type;
        if(scheme_type){
            this.setState({'scheme_type' : scheme_type})
            var response = await Api.GetRequest({}, 'schemes-and-services');
            if(response.status == 200){
                this.setState({'categories' : response.categories});
            }
            else{
                toast.error("Something went wrong. Please try again later.");
            }
        }
        else{
            this.props.navigate(-1)
        }
       
    }
  

    constructor(props) {
        super(props);
        this.state = {
            'scheme_type' : "",
            'categories' : []
        };
    }


    showSchemes = async(category)=>{
        if(this.state.scheme_type == 'central'){
            this.props.navigate("/schemes/central/"+category)
        }
        else{
            this.props.navigate("/schemes/map/"+category)
        }
    }
    

    render(){

        return(
            <>
                <div class="m-0 shadow"  style={{'width' : '100vw!important', 'maxWidth' : '100vw!important'}}>
                    <div class="row mx-0">
                        <div class="col-lg-12 p-0">
                            <div class="commn_banner_page" style={{'position' : 'relative'}}>
                                <img src="/assets/img/header_banner.png" class="page-banner-image" style={{'width' : '100vw'}}/>
                                <h2 className="mb-0 page-label" style={{'position' : 'absolute', textAlign : 'left', 'top' : '40%',  width:'50%', lineHeight:'normal', 'left' : '10%', 'color' : '#000000', "textTransform" : "uppercase"}}>Central Govt. Schemes</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <section id="trending_causes_main" class="px-2" style={{'marginTop':'50px', 'marginBottom' : '50px'}}>
                    <div class="container-fluid">
                        <div class="row mx-0" id="counter">
                            {this.state.categories.map((category)=>{
                                return(
                                    <div class="col-lg-3 col-md-4 col-sm-12 col-12">
                                        <div class="case_boxed_wrapper bordered" style={{'border' : '1px solid #000000'}}>
                                            <div class="case_boxed_img">
                                                <a href="javascript:;" onClick={()=>{this.showSchemes(category.id)}}>
                                                    <img src={process.env.REACT_APP_SERVER + category.image} alt="img"/>
                                                </a>
                                            </div>
                                            <div class="causes_boxed_text">
                                                <h5 style={{'height' : '43px'}}>
                                                    <a style={{'color' : '#000000'}} href="javascript:;" onClick={()=>{this.showSchemes(category.id)}} class="card-title">{category.title}</a>
                                                </h5>
                                                <a href="javascript:;" onClick={()=>{this.showSchemes(category.id)}}><button className="btn btn_theme btn_md mt-3 py-1">Click Here</button></a>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </section>
            </>
        )
    }
}


export default withRouter(SchemesServices)